import common from 'store/modules/common/api'

export const api = {
  getEntity: () => common.httpClient.get(`/api/services/app/BackgroundActions/GetAll`, common.options()).then(r => common.processResponse(r)),
}
